import Cookies from "universal-cookie";
import { useAuthContext } from "./useAuthContext";

export const useLogout = () => {
  const { dispatch } = useAuthContext();
  const cookies = new Cookies(null, { path: "/" });
  const logout = () => {
    // remove user cookie
    cookies.remove("token");
    cookies.remove("username");
    cookies.remove("userId");
    cookies.remove("isAdmin");
    cookies.remove("isModerator");
    cookies.remove("fullName");
    sessionStorage.clear();
    dispatch({ type: "LOGOUT" });
  };
  return { logout };
};
